<ng-container *ngIf="rowCommandTemplateRef && !row.isEdit">
  <button class="grid-command datex-button {{gridOptionsMenu.menuOpen ? 'open' : ''}}"
          [matMenuTriggerFor]="optionsMenu"
          #gridOptionsMenu="matMenuTrigger">
    <i class="icon icon-ic_fluent_more_horizontal_20_regular"></i>
  </button>
  <mat-menu #optionsMenu="matMenu"
            class="options-menu">
    <ng-container *ngTemplateOutlet="rowCommandTemplateRef; context: {$implicit: row }">
    </ng-container>
  </mat-menu>
</ng-container>